(() => {
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const productInfo = select.closest('.kt-product-info');
      const priceNode = productInfo?.querySelector('[data-product-price] .kt-price span');

      if (priceNode && option?.dataset.price) {
        priceNode.textContent = option.dataset.price;
      }
    });
  });

  document.querySelectorAll('.kt-product-thumb').forEach((thumb) => {
    thumb.addEventListener('click', (event) => {
      const image = thumb.querySelector('img');
      const mainImage = document.querySelector('.kt-product-media-main img');

      if (!image || !mainImage) return;

      event.preventDefault();
      mainImage.src = thumb.href;
      mainImage.srcset = '';
      mainImage.alt = image.alt;
    });
  });

  document.querySelectorAll('.kt-mobile-panel a').forEach((link) => {
    link.addEventListener('click', () => {
      const details = link.closest('details');
      if (details) details.open = false;
    });
  });
})();
